var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from "react";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { getUserNameFromStorage } from "ah_utility/AuthValidation";
import { searchPermissionInRoles } from "../../../../../utils/authUtils";
import { postLoginAPI } from "../../../../../resources/helper/login";
import { showToastSuccessMessage } from "../../../../../fnx/sendSuccessMessage";
export var useCancelConfirmationModal = function (_a) {
    var onClose = _a.onClose, onSubmit = _a.onSubmit, reasonOptions = _a.reasonCancellation, setSeeToast = _a.setSeeToast;
    var _b = useState(""), selectedReason = _b[0], setSelectedReason = _b[1];
    var _c = useState(getUserNameFromStorage() || ""), userName = _c[0], setUserNameState = _c[1];
    var _d = useState(""), userNameError = _d[0], setUserNameError = _d[1];
    var _e = useState(""), password = _e[0], setPasswordState = _e[1];
    var _f = useState(""), passwordError = _f[0], setPasswordError = _f[1];
    var _g = useState(false), isValidating = _g[0], setIsValidating = _g[1];
    useEffect(function () {
        if ((reasonOptions === null || reasonOptions === void 0 ? void 0 : reasonOptions.length) > 0) {
            setSelectedReason(reasonOptions[0].value);
        }
    }, [reasonOptions]);
    var handleClose = function () {
        setPasswordState("");
        setPasswordError("");
        setUserNameError("");
        onClose();
    };
    var setUserName = function (value) {
        setUserNameState(value);
        setUserNameError("");
    };
    var setPassword = function (value) {
        setPasswordState(value);
        setPasswordError("");
    };
    var validateAndSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var loginResponse, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setUserNameError("");
                    setPasswordError("");
                    if (!userName.trim()) {
                        setUserNameError("Debe ingresar el usuario");
                        return [2 /*return*/];
                    }
                    if (!password) {
                        setPasswordError("Debe ingresar la contraseña");
                        return [2 /*return*/];
                    }
                    setIsValidating(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, postLoginAPI({ userName: userName, password: password })];
                case 2:
                    loginResponse = _a.sent();
                    if (!searchPermissionInRoles(loginResponse, "sale-policies-sumary-cancel")) {
                        showToastSuccessMessage("El usuario no cuenta con el permiso para cancelar", typeAlert.error, setSeeToast);
                        setPasswordState("");
                        onClose();
                        return [2 /*return*/];
                    }
                    onSubmit(selectedReason);
                    setPasswordState("");
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    setPasswordError("Contraseña incorrecta");
                    return [3 /*break*/, 5];
                case 4:
                    setIsValidating(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        selectedReason: selectedReason,
        userName: userName,
        userNameError: userNameError,
        password: password,
        passwordError: passwordError,
        isValidating: isValidating,
        setSelectedReason: setSelectedReason,
        setUserName: setUserName,
        setPassword: setPassword,
        handleClose: handleClose,
        validateAndSubmit: validateAndSubmit,
    };
};
